module.exports = __webpack_public_path__ + "img/open_vip.8075ff88.png";